export default __webpack_public_path__ + "static/media/JavaDevelopers.a807551d.jpg";